import './common'
import Vue from 'vue'
import 'bootstrap/scss/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

window.BBCL.asyncs.push(
    import(/* webpackChunkName: "bootstrap-vue" */ 'bootstrap-vue').then(BootstrapVue => Vue.use(BootstrapVue))
)
